import React from 'react'
import { Grid } from 'react-styled-flexboxgrid'
import { ThemeProvider } from 'styled-components'
import FlexBoxGridTheme from './flexBoxGridTheme'

const GridContainer = ({ children }) => {
  return (
    <ThemeProvider theme={FlexBoxGridTheme}>
      <Grid
        style={{
          // display: 'flex',
          // flexDirection: 'column',
          // flexGrow: 1,
          width: '100%',
        }}
      >
        {children}
      </Grid>
    </ThemeProvider>
  )
}

export default GridContainer
